import '../../themes/confirm_hyg.scss';
import '../../themes/global.scss';

import { Avatar, Column, Row } from '@tempmee/react';
import { Colors } from '../../themes/colors';
import { getProfessionalName } from '~/utils/professional';

interface IChatHeaderProps {
  userInfo?: { profile_image?: string; first_name?: string; last_name?: string };
  jobDate?: string;
  isOnsiteInterview?: boolean;
}

// Avatar + name/date rendered in Screen.Header's `children` area (below the fixed
// 44px title row), so it flows freely and stays centered without colliding with the
// absolute start (back) / end (action buttons) slots. The teal background is
// supplied by Screen.Header in Chat.js.
export default function ChatHeader({ userInfo, jobDate, isOnsiteInterview }: IChatHeaderProps) {
  return (
    <Row gap={5} align="center" justify="center">
      <Avatar size="2xl" src={userInfo?.profile_image || undefined} alt="profile_image" />

      <Column>
        <h4
          style={{
            fontSize: 22,
            color: Colors.white,
            fontFamily: 'Nunito',
            fontWeight: 'bold',
            margin: 0,
          }}
        >
          {getProfessionalName(userInfo)}
        </h4>

        <div className="global_font" style={{ color: Colors.white }}>
          {isOnsiteInterview ? 'Interview' : 'Shift'} Date: {jobDate}
        </div>
      </Column>
    </Row>
  );
}
